<template>
  <section v-if="favoriteShows">
    <template>
    <div class="filter search_only">
      <div class="field_left">
        <p class="field">
          <label for="vyhledavani" v-translate>Vyhledávání</label>
          <input class="search clearable" id="vyhledavani" name="vyhledavani" size="30" v-model="searchText"
                 type="text">
          <a @click="clearFilter" id="vyhledavani_delete" class="clearable_btn" :title="$gettext('Vymazat text')"
             :style="{display: (this.searchText ? 'inline' : 'none')}" v-translate>Vymazat</a>
        </p>
      </div>
    </div>

    <div class="table_overflow">
      <table class="vypis">
      <thead>
      <tr v-if="filteredFavoriteShows.length > 0">
        <th class="no_padding drag_drop"></th>
        <th class="no_padding checkbox"></th>
        <th><span class="name"><strong v-translate>Název</strong></span></th>
        <th><span v-translate>Uživatelský profil</span></th>
        <th><span v-translate>Vytvořilo zařízení</span></th>
        <th><span v-translate>Datum vytvoření</span></th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <tbody>
      <FavoriteShowsRow
          v-for="entity in filteredFavoriteShows"
          :entity ="entity"
          :enabled="entity.favorite_show_enabled"
          :selectedEntities="selectedEntities"
          @input="select"
          :key="entity.id"
          :is-deletable="isEditable"
          @deleteFavoriteShow="onDeleteFavoriteShow"/>
      <tr v-if="filteredFavoriteShows.length === 0">
        <td colspan="6" v-translate>Nebyly nalezeny žádné oblíbené pořady.</td>
      </tr>
      </tbody>
    </table>
    </div>
    </template>
    <local-list-action-line
        :entities="filteredFavoriteShows"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        @select-all="toggleSelectAll"
        @run-multiple-action="executeMultipleAction"
    ></local-list-action-line>
  </section>
</template>

<script>
import FavoriteShowsRow from "./FavoriteShowsRow";
import localTable from "@/components/mixins/local-table"

export default {
  name: "FavoriteShows",
  components: {FavoriteShowsRow},
  mixins: [localTable],
  props: {
    favoriteShows: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    clearFilter() {
      this.searchText = "";
    },
    onDeleteFavoriteShow(id) {
      this.$emit('deleteFavoriteShow', id);
    },
    executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeleteFavoriteShow(actionIds);
          break;
        default:
          this.runMultipleAction(action, activeKey);
      }
    }
  },
  computed: {
    entities(){
      return Object.values(this.filteredFavoriteShows);
    },
    csvHeaders(){
      return {
          'name': {name: this.$gettext('Název')},
          'id_subscriber_profile': {name: this.$gettext('Uživatelský profil'), callback: (entity) => {return entity.subscriber_profile_name }},
          'device_name': {name: this.$gettext('Vytvořilo zařízení')},
          'timestamp_created': {name: this.$gettext('Datum vytvoření')}
        }
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
    filteredFavoriteShows() {
      if (!this.searchText) {
        return this.favoriteShows.favorite_shows;
      }

      let searchText = this.searchText.toLowerCase();

      return this.favoriteShows.favorite_shows.filter((favoriteShow) => {
        return favoriteShow.name.toLowerCase().includes(searchText) ||
            favoriteShow.device_name.toLowerCase().includes(searchText);
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/favoriteShows/FavoriteShows.vue